import { Button } from '@/components/ui-kit/button';
import { ArrowLeft, ShieldX } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const OrgUnauthorizedPage = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-linear-to-b from-[hsl(var(--gradient-light-from))] to-[hsl(var(--gradient-light-to))]">
      <div className="text-center max-w-md mx-auto px-4">
        <div className="flex justify-center mb-6">
          <div className="p-4 rounded-full bg-crimson/10">
            <ShieldX className="h-12 w-12 text-crimson" />
          </div>
        </div>

        <h1 className="text-2xl font-bold text-[hsl(var(--fg))] font-heading mb-2">
          {t('ONBOARDING_ACCESSDENIED_TITLE', 'Access Denied')}
        </h1>

        <p className="text-globe-grey mb-6">
          {t(
            'ONBOARDING_ACCESSDENIED_DESCRIPTION',
            'You do not have permission to access this organization.'
          )}
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button asChild variant="outline">
            <Link to="/">
              <ArrowLeft className="h-4 w-4 mr-2" />
              {t('ONBOARDING_ACCESSDENIED_GOHOME', 'Go Home')}
            </Link>
          </Button>
          <Button asChild>
            <Link to="/org/select">
              {t('ONBOARDING_ACCESSDENIED_BROWSETEMPLATES', 'Browse Organizations')}
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default OrgUnauthorizedPage;
